import React from 'react';
import ProductCard from '../components/ProductCard';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    title: 'Bitter Gourd Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Bitter Gourd Karam Podi.jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
  {
    id: 2,
    title: 'Coconut Karam Podi.jpg',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Coconut Karam Podi.jpg',
    images: [
      './assets/pandumirapa/pandumirapa-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 3,
    title: 'Coriander Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Coriander Karam Podi.jpg',
    images: [
      './assets/tomato/tomato-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 4,
    title: 'Curry Leaves Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Curry Leaves Karam Podi.jpg',
    images: [
      './assets/lemon/lemon-2.jpg',
      './assets/lemon/lemon-1.jpg',
      './assets/lemon/lemon-2.jpg',
    ],
  },
  {
    id: 5,
    title: 'Garlic Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Garlic Karam Podi.jpg',
    images: [
      './assets/allam/allam-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 6,
    title: 'Groundnut Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Groundnut Karam Podi.jpg',
    images: [
      './assets/gongura/gongura-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 7,
    title: 'Idli Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Idli Karam Podi.jpg',
    images: [
      './assets/munaga/munaga-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 8,
    title: 'Kandi Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Kandi Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 9,
    title: 'Kothimeera Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Kothimeera Karam Podi.jpg',
    images: [
      './assets/donda/donda-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
     },
  {
    id: 8,
    title: 'Masala Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Masala Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
     },
  {
    id: 8,
    title: 'Munagaku Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Munagaku Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
     },
  {
    id: 8,
    title: 'Nalla Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Nalla Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
       },
  {
    id: 8,
    title: 'Nuvvula Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Nuvvula Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
     },
  {
    id: 8,
    title: 'Prawn Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 1000,
    imageMain: './assets/Prawn Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
   },
  {
    id: 8,
    title: 'Pudina Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Pudina Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  }
  // ... more products
];

function PowdersMenuPage() {
  return (
    <Container className='mt-4 mb-4'>
      <Row>
        {products.map((product, index) => (
          <Col md={4} key={index} className='mt-4 mb-4'>
            {/* <Link to={`/product/${product.id}`}> */}
            <ProductCard product={product} />
            {/* </Link> */}
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default PowdersMenuPage;
